module.exports = __webpack_public_path__ + "media/landing_page/iss-f2433c4e.jpg";